export default __webpack_public_path__ + "static/media/orbital_apollo.c3e8994e.png";